"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox as ChakraCheckbox, useMultiStyleConfig, forwardRef, } from "@chakra-ui/react";
import { getCheckmarkColor } from "./Checkbox.helpers";
import { SvgSpriteConsumer } from "../SvgSprite";
import "focus-visible/dist/focus-visible";
const HelpText = ({ text }) => {
    const styles = useMultiStyleConfig("Checkbox");
    return _jsx(Box, Object.assign({ sx: styles.helpText }, { children: text }));
};
const CheckmarkIcon = ({ isChecked, color, sx }) => isChecked ? (_jsx(SvgSpriteConsumer, { sx: sx, svgId: "checkmark16", color: color })) : null;
const MinusIcon = () => (_jsx(SvgSpriteConsumer, { svgId: "minus24", size: 24, sx: { width: "100% !important", height: "100% !important" } }));
const Checkbox = forwardRef((_a, ref) => {
    var { children, isDisabled, isReadOnly, isInvalid, isIndeterminate, variant, size, helpText } = _a, rest = __rest(_a, ["children", "isDisabled", "isReadOnly", "isInvalid", "isIndeterminate", "variant", "size", "helpText"]);
    const styles = useMultiStyleConfig("Checkbox", {
        size,
        isReadOnly,
    });
    return (_jsxs(Box, Object.assign({ sx: styles.wrapper }, { children: [_jsx(ChakraCheckbox, Object.assign({ ref: ref, icon: isIndeterminate ? (_jsx(MinusIcon, {})) : (_jsx(CheckmarkIcon, { sx: styles.icon, color: getCheckmarkColor({
                        isDisabled,
                        isReadOnly,
                        isInvalid,
                    }) })), isDisabled: isDisabled, isReadOnly: isReadOnly, isInvalid: isInvalid, isIndeterminate: isIndeterminate, size: size }, rest, { children: children })), helpText ? _jsx(HelpText, { text: helpText }) : null] })));
});
Checkbox.displayName = "Checkbox";
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map